import React from "react";
import { Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { TruncatedText } from "../../../components/truncateText";
import { GlobalSpinner, PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from "material-table";
import moment from "moment";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import _ from "lodash";


const styles = {
  card: {
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "10px",
    textAlign: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    backgroundColor: "#81ABD3",
  },
  container: {
    display: "flex",
    gap: "15px",
    margin: "10px",
  },
  heading: {
    fontSize: "15px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  data: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#333",
  },
};
const InventoryLegderDetail = ({ searchInventoryLedgerList, isFetchingSearchInventoryLedger }) => {
  if (isFetchingSearchInventoryLedger) {
    return (
      <GlobalSpinner />
    );
  }

  const ledgerCards = [
    { title: "Product Name", data: `${searchInventoryLedgerList?.code} - ${searchInventoryLedgerList?.productName}` || "" },
    // { title: "Opening Balance", data: `${searchInventoryLedgerList.data?.[0]?.closingBalance.toLocaleString()}/-` || 0 },
    { title: "Total Add Quantity", data: `${searchInventoryLedgerList?.addQuantity}` || 0 },
    { title: "Total Less Quantity", data: `${searchInventoryLedgerList?.lessQuantity}` || 0 },
    { title: "Closing Balance", data: `${searchInventoryLedgerList?.closing_balance}` || 0 },
    { title: "Start Date - End Date", data: `${moment(searchInventoryLedgerList?.startDate).format("DD-MM-YYYY")} - ${moment(searchInventoryLedgerList?.endDate).format("DD-MM-YYYY")}` || "" },
  ];

  return (
    <Container fluid>
      <div className="sendDiv" style={{ marginTop: '-15px' }}>
        <Link to="/inventory/ledger">
          <Button><b>BACK TO SEARCH</b></Button>
        </Link>
      </div>

      <div style={styles.container}>
        {ledgerCards.map((card, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.heading}>{card.title}</div>
            <div style={styles.data}>{card.data}</div>
          </div>
        ))}
      </div>

      <MaterialTable
        columns={[
          { title: "Date", field: "transactionDate", render: rowData => moment(rowData.transactionDate).format('DD-MM-YYYY') },
          {
            title: "Description", field: "description",
            render: rowData => <TruncatedText text={rowData?.description} maxLength={80} />
          },
          { title: "Add Quantity", field: "addQuantity" },
          { title: "Less Quantity", field: "lessQuantity" },
          { title: "Closing Balance", field: "closingBalance" },
        ]}
        data={searchInventoryLedgerList.data || []}
        options={{
          exportButton: true,
          toolbar: true,
          showTitle: false,
          actionsColumnIndex: -1,
          paging: true,
          pageSize: 50,
          pageSizeOptions: [50, 100, 150, 200],
          emptyRowsWhenPaging: false,
          search: true,
          headerStyle: {
            position: "sticky",
            top: 0,
            color: "#00BBBB",
            fontWeight: "550",
            fontSize: "13px",
            padding: "4px 8px",
            // backgroundColor: "#f1f1f1",
            borderBottom: "2px solid #ddd" // Add bottom border to header
          },
          cellStyle: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "13px",
            padding: "6px 10px",
            border: "1px solid #ddd" // Add border for grid effect
          },
          rowStyle: {
            fontSize: "13px",
            padding: "6px 10px",
            lineHeight: "1",
            borderBottom: "1px solid #ddd", // Add bottom border between rows
            backgroundColor: "#fff" // Ensure background is white
          },
          exportPdf: (columns, data) => {
            const unit = "pt";
            const size = "A4";
            const orientation = "l";
            const doc = new jsPDF(orientation, unit, size);
            PDFHeader(doc, "Store Ledger");

            const columnTitles = columns.map(columnDef => columnDef.title);
            const pdfData = data.map((elt) => [
              moment(elt.transactionDate).format('DD-MM-YYYY'),
              elt.description,
              elt.addQuantity,
              elt.lessQuantity,
              elt.closingBalance,
            ]);
            if (!_.isEmpty(pdfData)) {
              pdfData.push([
                "",
                { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(pdfData, '2').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(pdfData, '3').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
              ])
            }
            let content = {
              startY: 135,
              startX: 5,
              head: [columnTitles],
              body: pdfData,
              headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
              styles: { fontSize: 9 },
              theme: "grid",
            };

            doc.setFontSize(12)
            doc.setFont("Times New Roman", "Bold")
            doc.text(`Start Date: ${moment(searchInventoryLedgerList?.startDate).format("DD-MM-YYYY")} - End Date: ${moment(searchInventoryLedgerList?.endDate).format("DD-MM-YYYY")}`, 50, 120, 0, 20);
            doc.autoTable(content);

            doc.setProperties({ title: 'Store Ledger' })
            doc.output('dataurlnewwindow')
          },
        }}
      />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  searchInventoryLedgerList: state.InventoryLegderReducer.searchInventoryLedgerList,
  isFetchingSearchInventoryLedger: state.InventoryLegderReducer.isFetchingSearchInventoryLedger,
});

export default connect(mapStateToProps)(InventoryLegderDetail);